import * as z from "zod";
import { linnworksReturnsSettingsSchema } from "./linnworks-returns-settings-schema";

export const getLinnworksReturnsSettings = {
  name: "getLinnworksReturnsSettings" as const,
  input: z.object({}),
  output: z.object({ settings: linnworksReturnsSettingsSchema }),
};
